import { createBrowserRouter, RouterProvider } from "react-router-dom";

import BackLogin from "../page/back/login";

import FrontRoutes from "./front";
import BackRoutes from "./back";

export default function CreatRoute() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <BackLogin />,
    },
    ...FrontRoutes.routes,
    ...BackRoutes.routes,
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}
